import { Pipe, PipeTransform } from '@angular/core';
import { differenceInYears } from 'date-fns';
import { DateService } from 'src/app/core/services/date.service';

@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  transform(value: string | number | Date): number {
    if (value != null) {
      const nowMidnightUTC = this.dateService.now(false, 'UTC');
      return differenceInYears(nowMidnightUTC, new Date(value));
    }

    return null;
  }
}
